import { render } from "./NewWarehouse.vue?vue&type=template&id=9d845e1a&ts=true"
import script from "./NewWarehouse.vue?vue&type=script&lang=ts"
export * from "./NewWarehouse.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__